<template>
  <div class="index-fornitura">
    <div class="dashboard" :style="{ height: (contenitoreHeight + 35) + 'px' }" v-if="showDashboard">

      <div class="col-24 header-country">
        <div class="contenitore-select">
          <div class="header-stato">
            {{ $t('indexFornitura.stato') }}
          </div>
          <el-select v-model="country" placeholder="" @change="changeCountry">
            <el-option
              v-for="item in countries"
              :key="item"
              :label="$t('indexFornitura')[item].toUpperCase()"
              :value="item">
            </el-option>
          </el-select>
        </div>
        <div class="contenitore-select" v-if="(typeOfUser === 'fornitore' && fornitori.length > 1)">
          <div class="header-stato">
            {{ $t('indexFornitura.fornitore') }}
          </div>
          <el-select v-model="fornitore" placeholder="" @change="changeFornitore">
            <el-option
              v-for="item in fornitori"
              :key="item.codForn"
              :label="item.codForn"
              :value="item.codForn">
              {{ (item.codForn + ' - ' + item.desForn) }}
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="row row-custom testata">
        <div class="card-testata col-xl-6 col-md-12 col-24 pointer" v-show="abilitatoSO">
          <dashboard-card-doppia :properties="ordiniAperti" @click.native="goToOrdini"></dashboard-card-doppia>
        </div>
        <div class="card-testata col-xl-6 col-md-12 col-24" v-show="abilitatoSO">
          <dashboard-card :properties="valoreOrdiniAperti"></dashboard-card>
        </div>
        <div class="card-testata col-xl-6 col-md-12 col-24" v-show="abilitatoSO">
          <dashboard-card :properties="ultimoOrdine"></dashboard-card>
        </div>
        <div class="card-testata col-xl-6 col-md-12 col-24 pointer" v-if="abilitatoRdO">
          <dashboard-card :properties="ultimaRDO" @click.native="goToOfferte"></dashboard-card>
        </div>
      </div>

      <div class="row row-custom centrale" v-show="abilitatoSO">
        <div class="col-xl-12 col-24 grafico-torta">
          <div class="col-24 grafico no-padding">

            <donut-chart
                  :title="($t('indexFornitura.titoloTorta').toUpperCase())"
                  :options="optionsTorta"
                  :chartData="rowsTorta"
                  :chartColumns="columnsTorta"
                  :isAdmin="isAdmin"
            ></donut-chart>

          </div>
        </div>
        <div class="col-xl-12 col-24 carosello" v-loading="caroselloLoading">
          <el-carousel :arrow="ifArrow" :autoplay="false" indicator-position="none" @change="changeScheda" v-if="(cards.length > 0)">
            <el-carousel-item v-for="scheda in nrSchede" :key="scheda">
              <div class="card-stabilimento" v-for="item in cards" :key="(item.codSoc + item.codMag)">
                <div class="scheda">
                  <div class="scheda-stab">
                    {{ item.desMag }}
                  </div>
                  <div class="scheda-nr-ordini">
                    {{ item.nrOrdAperti }}
                  </div>
                  <div class="scheda-label">
                    {{ $t('indexFornitura.ordini') }}
                  </div>
                  <div class="scheda-valore">
                    {{ item.valOrdAperti | formatValore }}
                  </div>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>

      <div class="col-24 footer" v-show="abilitatoSO">
        <div class="col-24 grafico">

          <column-chart
            :title="($t('indexFornitura.titoloIsto').toUpperCase())"
            :options="optionsIsto"
            :chartData="rowsIsto"
            :chartColumns="columnsIsto"
            :isAdmin="isAdmin"
          ></column-chart>

        </div>
      </div>

    </div>

    <keep-alive>
      <router-view :contenitoreHeight="contenitoreHeight"></router-view>
    </keep-alive>
  </div>
</template>

<script>
  import DashboardCard from '@/components/ServiceComponents/DashboardCard'
  import DashboardCardDoppia from '@/components/ServiceComponents/DashboardCardDoppia'
  import {bus} from '../Bus.js'
  import DonutChart from '../ServiceComponents/DonutChart.vue'
  import ColumnChart from '../ServiceComponents/ColumnChart.vue'

  export default {
    name: 'IndexFornitura',
    components: {
      DonutChart, ColumnChart,
      DashboardCard, DashboardCardDoppia
    },
    filters: {
      formatValore: function (val) {
        let euro = val.substr(0, val.length - 3)
        let euroElaborato = ''
        let j = euro.length - 1
        for (let i = 0; i < euro.length; i++) {
          euroElaborato = euroElaborato + euro[i]
          if (j % 3 === 0 && j !== 0) {
            euroElaborato = euroElaborato + '.'
          }
          j--
        }
        return euroElaborato + val.substr(val.length - 3, val.length) + ' €'
      }
    },
    i18n: {
      messages: {
        it_IT: {
          indexFornitura: {
            1: 'Italia',
            2: 'Francia',
            3: 'Spagna',
            4: 'Belgio',
            5: 'Germania',
            nOrdiniAperti: 'Ordini Aperti',
            nOrdiniConScaduto: 'Ordini con Scaduto',
            valore: 'Valore',
            ultimoOrdine: 'Ultimo Ordine',
            ultimaRDO: 'Ultima RDO',
            titoloTorta: 'Ordini aperti per stabilimento',
            ordini: 'ordini',
            titoloIsto: 'Situazione Ordini ultimi 4 anni (valore)',
            anno: 'Anno',
            stato: 'Stato: ',
            fornitore: 'Fornitore: '
          }
        },
        fr_FR: {
          indexFornitura: {
            1: 'Italie',
            2: 'France',
            3: 'Espagne',
            4: 'Belgique',
            5: 'Allemagne',
            nOrdiniAperti: 'N° Commandes Ouvertes',
            nOrdiniConScaduto: 'avec Expiré',
            valore: 'Valeur',
            ultimoOrdine: 'Dernière Commande',
            ultimaRDO: 'Dernier DDO',
            titoloTorta: 'Commandes ouvertes d\'usine',
            ordini: 'commandes',
            titoloIsto: 'Statut des Commandes des 4 dernières années (valeur)',
            anno: 'Année',
            stato: 'Nation: ',
            fornitore: 'Fournisseur: '
          }
        },
        es_ES: {
          indexFornitura: {
            1: 'Italia',
            2: 'Francia',
            3: 'España',
            4: 'Bélgica',
            5: 'Alemania',
            nOrdiniAperti: 'Pedidos Abiertos',
            nOrdiniConScaduto: 'Pendientes',
            valore: 'Valor',
            ultimoOrdine: 'Último Pedido',
            ultimaRDO: 'Pet. de Oferta',
            titoloTorta: 'Pedidos abiertos por sociedad',
            ordini: 'pedidos',
            titoloIsto: 'Situación pedidos de los utimos 4 años (valor)',
            anno: 'Año',
            stato: 'Estado: ',
            fornitore: 'Proveedor: '
          }
        },
        de_DE: {
          indexFornitura: {
            1: 'Italien',
            2: 'Frankreich',
            3: 'Spanien',
            4: 'Belgien',
            5: 'Deutschland',
            nOrdiniAperti: 'Offene Bestellungen',
            nOrdiniConScaduto: 'davon fällig',
            valore: 'Wert',
            ultimoOrdine: 'Letzte Bestellung',
            ultimaRDO: 'Letzte Angebotsanfrage',
            titoloTorta: 'Offene Aufträge nach Werken',
            ordini: 'aufträge',
            titoloIsto: 'Übersicht über Bestellungen der letzten 4 Jahre',
            anno: 'Jahr',
            stato: 'Land: ',
            fornitore: 'Lieferant: '
          }
        },
        en_GB: {
          indexFornitura: {
            1: 'Italy',
            2: 'France',
            3: 'Spain',
            4: 'Belgium',
            5: 'Germany',
            nOrdiniAperti: 'Nr. Open Orders',
            nOrdiniConScaduto: 'with Expired',
            valore: 'Value',
            ultimoOrdine: 'Last Order',
            ultimaRDO: 'Last OR',
            titoloTorta: 'Factory open orders',
            ordini: 'orders',
            titoloIsto: 'Orders\' Situation of last 4 years (value)',
            anno: 'Year',
            stato: 'Country: ',
            fornitore: 'Supplier: '
          }
        }
      }
    },
    props: {
      contenitoreHeight: {
        type: Number,
        required: true,
        default: 550
      }
    },
    data () {
      return {
        isAdmin: false,
        caroselloLoading: true,
        abilitatoSO: true,
        abilitatoRdO: true,
        nrSchede: 0,
        cards: [],
        columnsIsto: [
          {
          'type': 'string',
          'label': this.$t('indexFornitura.anno')
          },
          {
            'type': 'number',
            'label': ''
          }
        ],
        rowsIsto: [],
        optionsIsto: {
          height: 255,
          colors: ['#48adb5', '#bd3090', '#7d3d87', '#111858', '#2b6165', '#ccc', '#b5e2e6','#c1a9b9','#aca3ad','#665f75','#b97ccd'],
          legend: {
            position: 'right',
            textStyle: {
              color: '#007c74',
              fontName: 'os-regular',
              fontSize: 13
            }
          },
          chartArea: {
            width: '70%',
            top: 25,
            left: 75,
            height: 195
          }
        },
        columnsTorta: [{
          'type': 'string',
          'label': 'Stabilimento'
        }, {
          'type': 'number',
          'label': 'Ordini Aperti'
        }],
        rowsTorta: [],
        optionsTorta: {
          height: 280,
          pieHole: 0.5,
          backgroundColor: '#fff',
          chartArea: {
            width: '100%',
            top: 35,
            height: 210,
            left: 0
          },
          colors: ['#48adb5', '#bd3090', '#7d3d87', '#111858', '#2b6165', '#ccc', '#b5e2e6','#c1a9b9','#aca3ad','#665f75','#b97ccd'],
          fontName: 'os-regular',
          legend: {
            position: 'right',
            textStyle: {
              color: '#007c74',
              fontName: 'os-regular',
              fontSize: 13
            }
          },
          pieSliceTextStyle: {
            fontSize: 10
          },
          tooltip: {
            trigger: 'selection'
          }
        },
        countries: [],
        country: '',
        codLang: sessionStorage.getItem('codLang'),
        ordiniAperti: {
          bgColorUp: 'linear-gradient(to right, #00635c, #02b1a6)',
          bgColorDown: '#48adb5',
          iconColorUp: '#fff',
          iconColorDown: '#fff',
          titleUp: '',
          titleDown: '',
          iconaUp: 'riv-ordiniAperti',
          iconaDown: 'riv-hourglass',
          type: 'Numero',
          valueUp: '0',
          valueDown: '0'
        },
        valoreOrdiniAperti: {
          bgColor: 'linear-gradient(to right, #AC237F, #bb629f)',
          iconColor: '#fff',
          title: '',
          icona: 'riv-euro',
          type: 'Valore',
          valueEuro: '0',
          valueCentesimi: '00'
        },
        ultimoOrdine: {
          bgColor: 'linear-gradient(to right, #3e1844, #af55a8)',
          iconColor: '#fff',
          title: '',
          icona: 'riv-calendar2',
          type: 'Data',
          id: '',
          data: ''
        },
        ultimaRDO: {
          bgColor: 'linear-gradient(to right, #111858, #242f96)',
          iconColor: '#fff',
          title: '',
          icona: 'riv-calendar2',
          type: 'Data',
          id: '',
          data: ''
        },
        ordiniData: [],
        abilitazioni: [],
        codForn: '',
        ifAbilitatoSO: false,
        ifAbilitatoBdR: false,
        typeOfUser: '',
        fornitore: '',
        fornitori: []
      }
    },
    computed: {
      showDashboard: function () {
        let path = this.$route.path
        return (path === '/fornitura' || path === '/fornitura/')
      },
      ifArrow: function () {
        if (this.nrSchede > 1) {
          return 'always'
        } else {
          return 'never'
        }
      }
    },
    activated: function () {
      this.init()
    },
    deactivated: function () {
      this.resetDati()
    },
    mounted: function () {
      bus.$on('Header_SetCodFornAdmin', () => {
        this.resetDati()

        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['UFFACQ'][this.country])
        } else {
          this.$set(this, 'codForn', '')
        }

        this.getFornitoreInfo()
      })
      bus.$on('UFFACQ_ChangeCountryFromApp', () => {
        this.changeCountry(localStorage.getItem('UFFACQ_country'), true)
      })
      bus.$on('changeLanguage', () => {
        this.$set(this, 'codLang', sessionStorage.getItem('codLang'))
        this.$nextTick(() => {
          this.$set(this.ordiniAperti, 'titleUp', this.$t('indexFornitura.nOrdiniAperti'))
          this.$set(this.ordiniAperti, 'titleDown', this.$t('indexFornitura.nOrdiniConScaduto'))
          this.$set(this.valoreOrdiniAperti, 'title', this.$t('indexFornitura.valore'))
          this.$set(this.ultimoOrdine, 'title', this.$t('indexFornitura.ultimoOrdine'))
          this.$set(this.ultimaRDO, 'title', this.$t('indexFornitura.ultimaRDO'))
        })
      })
    },
    methods: {
      resetDati: function () {
        this.$set(this, 'caroselloLoading', true)
        this.$set(this, 'isAdmin', false)
        this.$set(this, 'abilitatoSO', true)
        this.$set(this, 'abilitatoRdO', true)
        this.$set(this, 'ifAbilitatoSO', false)
        this.$set(this, 'ifAbilitatoBdR', false)

        this.$set(this, 'cards', [])
        this.$set(this, 'ordiniData', [])
        this.$set(this, 'rowsTorta', [])
        this.$set(this.ordiniAperti, 'valueUp', '0')
        this.$set(this.ordiniAperti, 'valueDown', '0')
        this.$set(this.valoreOrdiniAperti, 'valueEuro', '0')
        this.$set(this.valoreOrdiniAperti, 'valueCentesimi', '00')
        this.$set(this.ultimoOrdine, 'id', '')
        this.$set(this.ultimoOrdine, 'data', '')

        this.$set(this.ultimaRDO, 'id', '')
        this.$set(this.ultimaRDO, 'data', '')

        this.$set(this, 'rowsIsto', [])
        let obj = {
          'type': 'number',
          'label' : ''
        }
        this.columnsIsto.splice(1, this.columnsIsto.length - 1)
        this.columnsIsto.push(obj)
        this.optionsIsto.colors[0] = '#fff'
      },
      init: function () {
        this.resetDati()
        this.getCountries()
        this.$nextTick(() => {
          this.ordiniAperti.titleUp = this.$t('indexFornitura.nOrdiniAperti')
          this.ordiniAperti.titleDown = this.$t('indexFornitura.nOrdiniConScaduto')
          this.valoreOrdiniAperti.title = this.$t('indexFornitura.valore')
          this.ultimoOrdine.title = this.$t('indexFornitura.ultimoOrdine')
          this.ultimaRDO.title = this.$t('indexFornitura.ultimaRDO')
        })
      },
      goToOrdini: function () {
        if (this.ifAbilitatoSO) {
          this.$router.push({ name: 'SOOrdini' })
        } else if (this.ifAbilitatoBdR) {
          this.$router.push({ name: 'BdROrdini' })
        }
      },
      goToOfferte: function () {
        if (this.abilitatoRdO) {
          this.$router.push({ name: 'RdOOfferte' })
        }
      },
      changeCountry: function (country, ifChangeCountryFromApp) {
        this.$set(this, 'country', parseInt(country))
        localStorage.setItem('UFFACQ_country', country)
  
        // Se sto cambiando Stato dalla dashboard cancello gli oggetti ricerca e il fornitore UFFACQ salvati nel sessionStorage
        if (!ifChangeCountryFromApp) {
          sessionStorage.removeItem('SO_form')
          sessionStorage.removeItem('SO_ordine')
          sessionStorage.removeItem('BdR_form')
          sessionStorage.removeItem('BdR_ordine')
          sessionStorage.removeItem('RdO_form')
          sessionStorage.removeItem('RdO_offerta')
          this.$store.commit('set', {key: 'RDQ_Ricerca', value: {}})
          this.$store.commit('set', {key: 'RDQ_Quotazione', value: {}})
          sessionStorage.removeItem('UFFACQ_fornitore')
        }

        // Emetto evento cambio Stato dalla dashboard UFFACQ
        bus.$emit('UFFACQ_ChangeCountryFromDsh')
  
        // Se esiste l'oggetto amministrazione nel localStorage recupero il codForn UFFACQ del nuovo Stato
        if (localStorage.hasOwnProperty('amministrazione')) {
          this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['UFFACQ'][this.country])
        } else {
          this.$set(this, 'codForn', '')
        }

        // Emetto evento per informare HeaderApp del cambio Stato
        bus.$emit('Header_ChangeAdmin', this.country, 'UFFACQ')

        this.resetDati()

        this.getFornitoreInfo()
      },
      verificaAbilitazioni: function () {
        // this.$set(this, 'abilitatoRdO', false)
        // this.$set(this, 'abilitatoSO', false)
  
        for (let i = 0; i < this.abilitazioni.length; i++) {
          let obj = this.abilitazioni[i]
          if (obj.area === 'UFFACQ') {
            for (let j = 0; j < obj.apps.length; j++) {
              let app = obj.apps[j]
              // Imposto i flag per le autorizzazioni per le applicazioni degli ordini
              if ((app.codiApp === 'SituazioneOrdini' || app.codiApp === 'WebBuoniDiRitiro') && JSON.parse(app.countries).indexOf(this.country) >= 0) {
                // this.$set(this, 'abilitatoSO', true)
                if (app.codiApp === 'SituazioneOrdini') {
                  this.$set(this, 'ifAbilitatoSO', true)
                }
                if (app.codiApp === 'WebBuoniDiRitiro') {
                  this.$set(this, 'ifAbilitatoBdR', true)
                }
              }
              // Imposto il flag per le autorizzazioni per l'applicazione delle offerte
              else if (app.codiApp === 'WebRichiestaOfferta' && JSON.parse(app.countries).indexOf(this.country) >= 0) {
                // this.$set(this, 'abilitatoRdO', true)
              }
            }
            /*
            // Se sono abilitato agli ordini chiamo i relativi servizi per la dashboard
            if (this.abilitatoSO) {
              this.getOrdiniDsh()
              this.getStoricoDsh()
            }
            // Se sono abilitato alle offerte chiamo il relativo servizio per la dashboard
            if (this.abilitatoRdO) {
              this.getOfferteDsh()
            }
            */

            // Richiamo tutti i servizi della dashboard indipendentemente dalle abilitazioni
            this.getOrdiniDsh()
            this.getStoricoDsh()
            this.getOfferteDsh()
          }
        }
      },
      changeScheda: function (newIndex, oldIndex) {
        this.$set(this, 'cards', [])
        for (let i = (newIndex * 4); i <= (newIndex * 4 + 3); i++) {
          let obj = this.ordiniData[i]
          if (obj !== null && obj !== undefined) {
            this.cards.push(this.ordiniData[i])
          }
        }
      },
      getCountries: function () {
        this.$http.get('portale/menu', {
          params: {
            codLang: this.codLang
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let data = response.body.data
              this.$set(this, 'abilitazioni', data)
              for (let i = 0; i < data.length; i++) {
                let obj = data[i]
                if (obj.area === 'UFFACQ') {
                  // Creo l'array con gli Stati per cui sono abilitato nelle applicazioni UFFACQ
                  let array = []
                  for (let j = 0; j < obj.apps.length; j++) {
                    let app = obj.apps[j]
                    let appCountries = JSON.parse(app.countries)
                    for (let k = 0; k < appCountries.length; k++) {
                      let country = appCountries[k]
                      if (array.indexOf(country) < 0) {
                        array.push(country)
                      }
                    }
                  }

                  // Popolo gli stati a cui sono abilitato e seleziono lo stato salvato nel localStorage (se è tra quelli a cui sono abilitato)
                  this.$set(this, 'countries', array)
                  if (localStorage.hasOwnProperty('UFFACQ_country') && this.countries.indexOf(parseInt(localStorage.getItem('UFFACQ_country'))) >= 0) {
                    this.$set(this, 'country', parseInt(localStorage.getItem('UFFACQ_country')))
                  } else {
                    this.$set(this, 'country', array[0])
                    localStorage.setItem('UFFACQ_country', array[0])
                  }

                  // Emetto l'evento per indicare a HeaderApp in quale area e in quale Stato sto lavorando
                  bus.$emit('Header_ChangeAdmin', this.country, 'UFFACQ')

                  // Richiamo il servizio per ottenere le info sull'utente
                  this.getFornitoreInfo()
                }
              }
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      getFornitoreInfo: function () {
        this.$http.get('dashboardacq/info', {
          params: {
            codLang: this.codLang,
            country: this.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              let attrib = response.body.attrib
              let data = response.body.data
              this.$set(this, 'typeOfUser', attrib.typeOfUser)

              // L'utente è un fornitore oppure agente
              if (this.typeOfUser === 'fornitore') {
                // Popolo l'elenco dei codForn (per l'agente saranno più di uno)
                this.$set(this, 'fornitori', data)
                // Se esiste salvato sul sessionStorage un fornitore per UFFACQ lo uso
                if (sessionStorage.hasOwnProperty('UFFACQ_fornitore')) {
                  this.$set(this, 'fornitore', sessionStorage.getItem('UFFACQ_fornitore'))
                  this.$set(this, 'codForn', sessionStorage.getItem('UFFACQ_fornitore'))
                }
                // Altrimenti uso il primo restituito dal servizio
                else {
                  this.$set(this, 'fornitore', data[0].codForn)
                  this.$set(this, 'codForn', data[0].codForn)
                  sessionStorage.setItem('UFFACQ_fornitore', this.codForn)
                }
              }
              // L'utente è amministratore (di tutte le applicazioni UFFACQ)
              else if (this.typeOfUser === 'admin') {
                // Imposto il codForn in base a ciò che è salvato nell'oggetto amministrazione
                if (localStorage.hasOwnProperty('amministrazione')) {
                  this.$set(this, 'codForn', (JSON.parse(localStorage.getItem('amministrazione')))['UFFACQ'][this.country])
                } else {
                  this.$set(this, 'codForn', '')
                }
              }

              // Chiamo il servizio per la verifica delle abilitazioni (Ordini e/o Offerte)
              this.verificaAbilitazioni()
            } else {
              this.$message({
                showClose: true,
                message: response.body.msg[0].msgTxt,
                type: 'error',
                duration: process.env.duration
              })
            }
          })
      },
      changeFornitore: function () {
        this.$set(this, 'codForn', this.fornitore)
        this.$set(this, 'caroselloLoading', true)
        sessionStorage.setItem('UFFACQ_fornitore', this.codForn)
        sessionStorage.removeItem('SO_form')
        sessionStorage.removeItem('SO_ordine')
        sessionStorage.removeItem('BdR_form')
        sessionStorage.removeItem('BdR_ordine')
        sessionStorage.removeItem('RdO_form')
        sessionStorage.removeItem('RdO_offerta')
        this.$store.commit('set', {key: 'RDQ_Ricerca', value: {}})
        this.$store.commit('set', {key: 'RDQ_Quotazione', value: {}})

        // Sul cambio del codForn resetto tutti i dati e riparto dalla verifica delle abilitazioni (per settare nuovamente i flag di abilitazione)
        this.resetDati()
        this.verificaAbilitazioni()
      },
      getOrdiniDsh: function () {
        this.$http.get('dashboardacq/ordini', {
          params: {
            codForn: this.codForn,
            codLang: this.codLang,
            country: this.country
          }
        })
          .then(response => {
            try {
              if (response.body.rc === 0) {
                this.$set(this.ordiniAperti, 'valueUp', response.body.attrib.nrOrdAperti)
                this.$set(this.ordiniAperti, 'valueDown', response.body.attrib.nrOrdParzScaduti)
                let val = response.body.attrib.valOrdAperti
                this.$set(this.valoreOrdiniAperti, 'valueCentesimi', val.substr(val.length - 2, 2))
                if (val.length > 3) {
                  let euro = val.substr(0, val.length - 3)
                  let euroElaborato = ''
                  let j = euro.length - 1
                  for (let i = 0; i < euro.length; i++) {
                    euroElaborato = euroElaborato + euro[i]
                    if (j % 3 === 0 && j !== 0) {
                      euroElaborato = euroElaborato + '.'
                    }
                    j--
                  }
                  this.$set(this.valoreOrdiniAperti, 'valueEuro', euroElaborato)
                }
                this.$set(this.ultimoOrdine, 'id', response.body.attrib.nrUltOrdine)
                this.$set(this.ultimoOrdine, 'data', response.body.attrib.dataUltOrdine)
                this.$set(this, 'ordiniData', response.body.data)

                this.nrSchede = (this.ordiniData.length % 4 > 0) ? (parseInt(this.ordiniData.length / 4) + 1) : (parseInt(this.ordiniData.length / 4))
                let i = 0
                while (i < 4) {
                  if (this.ordiniData[i] !== undefined) {
                    this.cards.push(this.ordiniData[i])
                  }
                  i++
                }

                let arrayTemp = []
                for (let i = 0; i < this.ordiniData.length; i++) {
                  let obj = this.ordiniData[i]
                  let array = [obj.desMag + ' - ' + obj.desSoc, parseInt(obj.nrOrdAperti)]
                  arrayTemp.push(array)
                }
                this.$set(this, 'rowsTorta', arrayTemp)
              } else {
                if (['1001', '0101'].indexOf(response.body.msg[0].msgId) < 0) {
                  this.$message({
                    showClose: true,
                    message: response.body.msg[0].msgTxt,
                    type: 'error',
                    duration: process.env.duration
                  })
                } else {
                  this.isAdmin = true
                }
                this.$set(this, 'rowsTorta', [])
                this.$set(this.ordiniAperti, 'value', '0')
                this.$set(this.valoreOrdiniAperti, 'valueEuro', '0')
                this.$set(this.valoreOrdiniAperti, 'valueCentesimi', '00')
                this.$set(this.ultimoOrdine, 'id', '')
                this.$set(this.ultimoOrdine, 'data', '')
                this.$set(this, 'cards', [])
                this.$set(this, 'ordiniData', [])
              }
              this.caroselloLoading = false
            }
            catch (err) {
              console.log(err)
            }
          })
      },
      getOfferteDsh: function () {
        this.$http.get('dashboardacq/offerte', {
          params: {
            codForn: this.codForn,
            codLang: this.codLang,
            country: this.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.$set(this.ultimaRDO, 'id', response.body.data.nrUltRicOff)
              this.$set(this.ultimaRDO, 'data', response.body.data.dataUltRicOff)
            } else {
              if (['1001', '0101'].indexOf(response.body.msg[0].msgId) < 0) {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              }
              this.$set(this.ultimaRDO, 'id', '')
              this.$set(this.ultimaRDO, 'data', '')
            }
          })
      },
      getStoricoDsh: function () {
        this.$http.get('dashboardacq/storico', {
          params: {
            nrAnni: 4,
            codForn: this.codForn,
            codLang: this.codLang,
            country: this.country
          }
        })
          .then(response => {
            if (response.body.rc === 0) {
              this.optionsIsto.colors[0] = '#48adb5'
              this.$set(this, 'columnsIsto', [])
              let colAnno = {
                'type': 'string',
                'label': 'Anno'
              }
              this.$set(this, 'columnsIsto', [colAnno])
              this.$set(this, 'rowsIsto', [])

              // Creo l'anagrafica degli stabilimenti
              let arrayStab = []
              for (let i = 0; i < response.body.data.length; i++) {
                let obj = response.body.data[i]
                for (let j = 0; j < obj.storico.length; j++) {
                  if (arrayStab.indexOf(obj.storico[j].desMag) < 0 && parseFloat(obj.storico[j].valOrdini) > 0) {
                    arrayStab.push(obj.storico[j].desMag)
                    this.columnsIsto.push({'type': 'number', 'label': obj.storico[j].desMag + ' - ' + obj.storico[j].desSoc})
                  }
                }
              }

              for (let i = 0; i < response.body.data.length; i++) {
                let obj = response.body.data[i]
                let array = ['0']
                arrayStab.forEach(() => {
                  array.push(0)
                })
                array[0] = (obj.anno)
                for (let j = 0; j < obj.storico.length; j++) {
                  if (parseFloat(obj.storico[j].valOrdini) > 0) {
                    array[arrayStab.indexOf(obj.storico[j].desMag) + 1] = (parseInt(obj.storico[j].valOrdini))
                  }
                }
                this.rowsIsto.push(array)
              }
            } else {
              if (['1001', '0101'].indexOf(response.body.msg[0].msgId) < 0) {
                this.$message({
                  showClose: true,
                  message: response.body.msg[0].msgTxt,
                  type: 'error',
                  duration: process.env.duration
                })
              } else {
                this.isAdmin = true
              }
              this.$set(this, 'rowsIsto', [])
              let obj = {
                'type': 'number',
                'label' : ''
              }
              this.columnsIsto.splice(1, this.columnsIsto.length - 1)
              this.columnsIsto.push(obj)
              this.optionsIsto.colors[0] = '#fff'
            }
          })
      }
    }
  }
</script>

<style lang="less">
  @import "../../assets/less/general.less";

  .index-fornitura {
    .dashboard {
      -webkit-box-shadow: 0 0 10px 2px #cecece;
      -moz-box-shadow: 0 0 10px 2px #cecece;
      box-shadow: 0 0 10px 2px #cecece;
      background-color: #ffffff;
      margin: auto;
      overflow-x: hidden;
      margin-top: 25px;
      .header-country {
        height: 45px;
        text-align: right;
        margin-top: 5px;
        .contenitore-select {
          display: inline-block;
          margin-left: 20px;
          .header-stato {
            .set-font(@size: 17px, @family: 'os-regular');
            text-align: right;
            line-height: 30px;
            display: inline-block;
            margin-right: 10px;
          }
          .el-select {
            width: 230px;
            display: inline-block;
            .el-input {
              .el-input__inner {
                border-radius: 0;
                border: 0;
                border-bottom: 1px solid #666;
                height: 35px;
                .set-font(@size: 18px, @family: 'os-semibold', @color: #bd3090);
                letter-spacing: 4px;
              }
              .el-select__caret {
                color: #666;
                font-size: 22px;
              }
            }
          }
        }
      }
      .testata {
        .card-testata {
          margin-bottom: 10px;
        }
      }
      .centrale {
        margin-top: 5px;
        .grafico-torta {
          height: 100%;
          margin-bottom: 15px;
          .grafico {
            border: 1px solid #e7e7e7;
            border-radius: 4px;
            -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
            -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
            box-shadow: 0px 0px 13px 1px #e7e7e7;
            .titolo-grafico {
              .set-font(@size: 13px; @weight: bold; @color: @greenRiva);
              letter-spacing: 3px;
              margin-top: 15px;
            }
          }
        }
        .carosello {
          height: 315px;
          margin-bottom: 15px;
          .el-carousel {
            height: 100%;
            .el-carousel__container {
              height: 100%;
              width: 100%;
              button:focus {
                outline: 0px auto;
              }
              .el-carousel__arrow {
                background-color: #fff;
                color: #ccc;
                font-size: 30px;
              }
              .el-carousel__item {
                padding-left: 10%;
                width: 90%;
                .card-stabilimento {
                  height: 50%;
                  width: 50%;
                  display: inline-block;
                  .scheda {
                    border: 1px solid #e7e7e7;
                    border-radius: 4px;
                    -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
                    -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
                    box-shadow: 0px 0px 13px 1px #e7e7e7;
                    width: 70%;
                    margin: 2% auto 2% auto;
                    height: 92%;
                    text-align: center;
                    .scheda-stab {
                      margin-top: 8px;
                      .set-font(@size: 18px; @color: #48adb5);
                    }
                    .scheda-nr-ordini {
                      margin-top: 10px;
                      .set-font(@size: 40px; @color: #bd3090);
                      line-height: 36px;
                    }
                    .scheda-label {
                      .set-font(@size: 16px; @color: #bd3090);
                    }
                    .scheda-valore {
                      margin-top: 5px;
                      .set-font(@size: 20px; @color: #3f2a6d);
                    }
                  }
                }
              }
            }
          }
        }
      }
      .footer {
        // margin-top: 5px;
        margin-bottom: 15px;
        .grafico {
          border: 1px solid #e7e7e7;
          border-radius: 4px;
          -moz-box-shadow: 0px 0px 13px 1px #e7e7e7;
          -webkit-box-shadow: 0px 0px 13px 1px #e7e7e7;
          box-shadow: 0px 0px 13px 1px #e7e7e7;
          .titolo-grafico {
            .set-font(@size: 13px; @weight: bold; @color: @greenRiva);
            letter-spacing: 3px;
            margin-top: 15px;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Fornitura/IndexFornitura.vue